import React from "react";
import {
  Col,
  Row,
  Label,
} from "reactstrap";

export default function EventNotActive() {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div>
            <Label htmlFor="formFile" className="form-label">
              {`O credenciamento não está ativo`}
            </Label>
          </div>
        </Col>
      </Row>
    </div>
  )
}
